import React, {useEffect} from "react";
import MainHeader from "../Components/MainHeader";

const NotFound=()=>{
    useEffect(() => {
                    document.title =
                      "Page Not Found | Iris Impulse India Pvt. Ltd.";
                
                    const metaDesc = document.querySelector("meta[name='description']");
                    if (metaDesc) {
                      metaDesc.setAttribute(
                        "content",
                        "The page you’re looking for doesn’t exist or has been moved. Explore Iris Impulse's range of Bentoninte & Industrial minerals or return to the homepage for the right solution."
                      );
                    }
                
                     const canonical = document.querySelector("link[rel='canonical']");
                  if (canonical) {
                    canonical.setAttribute("href", "https://irisimpulse.com/404");
                  }
                
                  const ogTitle = document.querySelector("meta[property='og:title']");
                  if (ogTitle) {
                    ogTitle.setAttribute(
                      "content",
                      "Page Not Found | Iris Impulse India Pvt. Ltd."
                    );
                  }
                
                    const ogDesc = document.querySelector("meta[property='og:description']");
                  if (ogDesc) {
                    ogDesc.setAttribute(
                      "content",
                      "The page you’re looking for doesn’t exist or has been moved. Explore Iris Impulse's range of Bentoninte & Industrial minerals or return to the homepage for the right solution."
                    );
                  }
                
                  const ogUrl = document.querySelector("meta[property='og:url']");
                  if (ogUrl) {
                    ogUrl.setAttribute("content", "https://irisimpulse.com/404");
                  }
                
                    const ogImage = document.querySelector("meta[property='og:image']");
                  if (ogImage) {
                    ogImage.setAttribute(
                      "content",
                      "https://irisimpulse.com/Images/home.webp"
                    );
                  }
                
                    const twitterTitle = document.querySelector("meta[name='twitter:title']");
                  if (twitterTitle) {
                    twitterTitle.setAttribute(
                      "content",
                      "Page Not Found | Iris Impulse India Pvt. Ltd."
                    );
                  }
                
                    const twitterDesc = document.querySelector(
                    "meta[name='twitter:description']"
                  );
                  if (twitterDesc) {
                    twitterDesc.setAttribute(
                      "content",
                      "The page you’re looking for doesn’t exist or has been moved. Explore Iris Impulse's range of Bentoninte & Industrial minerals or return to the homepage for the right solution."
                    );
                  }
                
                    const twitterImage = document.querySelector("meta[name='twitter:image']");
                  if (twitterImage) {
                    twitterImage.setAttribute(
                      "content",
                      "https://irisimpulse.com/Images/home.webp"
                    );
                  }
                  }, [])
    return(
        <>
         <MainHeader />

        <section className="container not-found-section">
             <h1 className="section-heading">404<br />Page Not Found!</h1>
            <p className="section-text"> The page you are looking for is not available or has been moved. Try a different page or go to
                  homepage with the button below.</p>
      <a
          href="/"
            className="outline-btn"
          >
        Go To Homepage
          </a>
        </section>
        </>
    )
}
export default NotFound;